"use client"

/**
 * Cookie Banner Component
 *
 * Fixed position banner for cookie consent with localStorage persistence
 */
import { useCookieConsent } from "../hooks/useInteractivity"
import Link from "next/link"

export default function CookieBanner() {
    const { showBanner, accept, decline } = useCookieConsent()

    if (!showBanner) return null

    return (
        <div
            id="cookie-banner"
            className="z-9999 fixed bottom-4 right-4 w-96 max-w-[calc(100vw-32px)] transform transition-all duration-300"
            style={{
                transform: showBanner ? "translateY(0)" : "translateY(120%)",
                opacity: showBanner ? 1 : 0
            }}>
            <div className="rounded-2xl border border-gray-100 bg-white p-5 shadow-lg">
                <p className="mb-4 text-sm text-dark">We use cookies to improve your experience on our site. By using our site you consent to cookies.</p>
                <div className="flex items-center gap-3">
                    <button onClick={accept} className="rounded-lg bg-outfame-black px-3 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-dark-400">
                        Accept
                    </button>
                    <button onClick={decline} className="rounded-lg bg-black/10 px-3 py-1.5 text-sm font-semibold text-outfame-black transition-colors hover:bg-black/20">
                        Decline
                    </button>
                    <Link href="/legal/privacy" className="ml-auto text-sm text-dark-400 transition-colors hover:text-dark">
                        Learn more
                    </Link>
                </div>
            </div>
        </div>
    )
}
